import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'pr-ai-notes-marketing-tooltip',
  imports: [MatButtonModule, MatIcon],
  templateUrl: './ai-notes-marketing-tooltip.component.html',
  styleUrl: './ai-notes-marketing-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiNotesMarketingTooltipComponent {
  heidiSignupUrl = 'https://www.heidihealth.com/en-au';
  connectAccount = output<void>();
}
